import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "file-list__ttl"
}
const _hoisted_2 = {
  key: 1,
  class: "file-list__list"
}

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  title?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'file-list',
  props: {
    modifires: { type: [String, Array, Boolean] },
    title: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('file-list', _ctx.modifires))
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})